module.exports = __webpack_public_path__ + "img/earth-africa.bfe91888.svg";